/**
 * Internal dependencies
 */
import SearchFilterTitle from 'src/components/common/search/searchFilterTitle';

const TITLE_NAME = 'Language';

const LanguageFilterTitle = ({ selectList }) => (
  <SearchFilterTitle title={TITLE_NAME} selectList={selectList} />
);

export default LanguageFilterTitle;
